const INITIAL_STATE = {
  companyLocals: null,
  loading: false,
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_LOCALS_REQUEST: 'locals/GET_LOCALS_REQUEST',
  GET_LOCALS_SUCCESS: 'locals/GET_LOCALS_SUCCESS',
  INCLUDE_LOCAL_REQUEST: 'locals/INCLUDE_LOCAL_REQUEST',
  EDIT_LOCAL_REQUEST: 'locals/EDIT_LOCAL_REQUEST',
  // INCLUDE_LOCAL_SUCCESS: 'locals/INCLUDE_LOCAL_SUCCESS',
  // EDIT_LOCAL_SUCCESS: 'locals/EDIT_LOCAL_SUCCESS',
  DELETE_LOCAL_REQUEST: 'locals/DELETE_LOCAL_REQUEST',
  DELETE_LOCAL_SUCCESS: 'locals/DELETE_LOCAL_SUCCESS',
};

/**
 * Reducer
 */
export default function locals(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LOCALS_REQUEST:
      return { ...state, loading: true };
    case Types.GET_LOCALS_SUCCESS:
      return { ...state, loading: false, companyLocals: action.payload };
    // case Types.INCLUDE_LOCAL_SUCCESS:
    // console.log(action.payload)
    //   return {
    //     ...state,
    //     companyLocals: {
    //       ...state.companyLocals,
    //       addresses: [action.payload, ...state.companyLocals.addresses],
    //     },
    //   };
    // case Types.EDIT_LOCAL_SUCCESS: {
    //   const { addresses: oldAdresses } = state.companyLocals;
    //   const { payload } = action;
    //   const addresses = oldAdresses.map(a => (a.id === payload.id ? payload : a));

    //   return {
    //     ...state,
    //     companyLocals: {
    //       ...state.companyLocals,
    //       addresses,
    //     },
    //   };
    // }
    case Types.DELETE_LOCAL_SUCCESS: {
      const { payload } = action;
      const deletedAddress = state.companyLocals.addresses.filter(
        address => address.id !== payload.addressId,
      );
      return {
        ...state,
        companyLocals: {
          ...state.companyLocals,
          addresses: deletedAddress,
        },
      };
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getLocalsRequest: payload => ({
    type: Types.GET_LOCALS_REQUEST,
    payload,
  }),
  getLocalsSuccess: payload => ({
    type: Types.GET_LOCALS_SUCCESS,
    payload,
  }),
  includeLocalRequest: payload => ({
    type: Types.INCLUDE_LOCAL_REQUEST,
    payload,
  }),
  editLocalRequest: payload => ({
    type: Types.EDIT_LOCAL_REQUEST,
    payload,
  }),
  deleteLocalRequest: payload => ({
    type: Types.DELETE_LOCAL_REQUEST,
    payload,
  }),
  // includeLocalSuccess: payload => ({
  //   type: Types.INCLUDE_LOCAL_SUCCESS,
  //   payload,
  // }),
  // editLocalSuccess: payload => ({
  //   type: Types.EDIT_LOCAL_SUCCESS,
  //   payload,
  // }),
  deleteLocalSuccess: payload => ({
    type: Types.DELETE_LOCAL_SUCCESS,
    payload,
  }),
};
